module.exports = __webpack_public_path__ + "img/face_pumpkins.6d8b49fe.jpg";